import React from 'react';
import './css/RoleOtherPermissions.css';

/**
 * Role-level options beyond object permissions (export, create report/dashboard).
 */
const RoleOtherPermissions = ({
  allowDataExport = true,
  allowReportExport = true,
  allowCreateReport = true,
  allowCreateDashboard = true,
  readOnly = false,
  saving = false,
  changed = false,
  onDataExportChange,
  onReportExportChange,
  onCreateReportChange,
  onCreateDashboardChange,
  className = '',
}) => {
  const dataDisabled = readOnly || saving;
  const reportDisabled = readOnly || saving || !allowDataExport;
  const createDisabled = readOnly || saving;
  const idPrefix = readOnly ? 'viewOtherPerm' : 'otherPerm';

  return (
    <section
      className={`role-other-permissions ${changed ? 'role-other-permissions--changed' : ''} ${className}`.trim()}
    >
      <div className="role-other-permissions-header">
        <h3>Other Permissions</h3>
      </div>

      <div className="permissions-table-container role-other-permissions-table-wrap">
        <table className="permissions-table role-other-permissions-table">
          <tbody>
            <tr>
              <td>
                <label className="role-other-perm-option" htmlFor={`${idPrefix}DataExport`}>
                  <input
                    type="checkbox"
                    id={`${idPrefix}DataExport`}
                    className="permission-checkbox"
                    checked={allowDataExport}
                    disabled={dataDisabled}
                    onChange={
                      readOnly
                        ? undefined
                        : (e) => onDataExportChange && onDataExportChange(e.target.checked)
                    }
                    title="Allow export from list views"
                  />
                  <span className="role-other-perm-label">Allow Data Export</span>
                </label>
              </td>
              <td>
                <label className="role-other-perm-option" htmlFor={`${idPrefix}ReportExport`}>
                  <input
                    type="checkbox"
                    id={`${idPrefix}ReportExport`}
                    className="permission-checkbox"
                    checked={allowDataExport && allowReportExport}
                    disabled={reportDisabled}
                    onChange={
                      readOnly
                        ? undefined
                        : (e) => onReportExportChange && onReportExportChange(e.target.checked)
                    }
                    title={
                      !allowDataExport && !readOnly
                        ? 'Enable data export first'
                        : 'Allow export from report viewer'
                    }
                  />
                  <span className="role-other-perm-label">Report Allow Export</span>
                </label>
              </td>
              <td>
                <label className="role-other-perm-option" htmlFor={`${idPrefix}CreateReport`}>
                  <input
                    type="checkbox"
                    id={`${idPrefix}CreateReport`}
                    className="permission-checkbox"
                    checked={allowCreateReport}
                    disabled={createDisabled}
                    onChange={
                      readOnly
                        ? undefined
                        : (e) => onCreateReportChange && onCreateReportChange(e.target.checked)
                    }
                    title="Allow creating and cloning reports"
                  />
                  <span className="role-other-perm-label">Allow Create Report</span>
                </label>
              </td>
              <td>
                <label className="role-other-perm-option" htmlFor={`${idPrefix}CreateDashboard`}>
                  <input
                    type="checkbox"
                    id={`${idPrefix}CreateDashboard`}
                    className="permission-checkbox"
                    checked={allowCreateDashboard}
                    disabled={createDisabled}
                    onChange={
                      readOnly
                        ? undefined
                        : (e) => onCreateDashboardChange && onCreateDashboardChange(e.target.checked)
                    }
                    title="Allow creating and cloning dashboards"
                  />
                  <span className="role-other-perm-label">Allow Create Dashboard</span>
                </label>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  );
};

export default RoleOtherPermissions;
